var map = {
	"./accounts.mdx": 69056,
	"./adding-custom-styles.mdx": 90986,
	"./appcustomisation.mdx": 48317,
	"./appfeatures.mdx": 11260,
	"./appstore.mdx": 35773,
	"./attributes.mdx": 25192,
	"./auth.mdx": 38430,
	"./branch.mdx": 56400,
	"./build-marketplace.mdx": 94485,
	"./category.mdx": 31910,
	"./chat.mdx": 87630,
	"./checklist.mdx": 63113,
	"./cloudflare.mdx": 26716,
	"./collection.mdx": 49128,
	"./commerce-definitions.mdx": 83544,
	"./commission.mdx": 67221,
	"./composer.mdx": 68939,
	"./coupon.mdx": 7000,
	"./crowdfunding.mdx": 37177,
	"./currency.mdx": 37607,
	"./deeplinks.mdx": 48576,
	"./delivery.mdx": 38819,
	"./deployment.mdx": 80390,
	"./domain.mdx": 61798,
	"./dynamic-page.mdx": 56331,
	"./editing-page-styles.mdx": 77659,
	"./editor-overview.mdx": 60285,
	"./education.mdx": 75562,
	"./email.mdx": 14095,
	"./energy.mdx": 37816,
	"./facebookapp.mdx": 21918,
	"./firebase.mdx": 9793,
	"./food.mdx": 30531,
	"./ga.mdx": 96569,
	"./google-maps.mdx": 76536,
	"./growth.mdx": 93959,
	"./integrations-overview.mdx": 62951,
	"./inventory.mdx": 89182,
	"./karix.mdx": 77992,
	"./language.mdx": 89406,
	"./listings.mdx": 11866,
	"./location.mdx": 26787,
	"./mangopay.mdx": 94691,
	"./media.mdx": 79297,
	"./negotiations.mdx": 30293,
	"./netlify.mdx": 53165,
	"./notifications.mdx": 33775,
	"./onlinepaymentplatform.mdx": 84096,
	"./order.mdx": 24521,
	"./othersolutions.mdx": 11906,
	"./paydunya.mdx": 64811,
	"./paymentgateways.mdx": 30688,
	"./playstore.mdx": 41394,
	"./products.mdx": 19904,
	"./promotion.mdx": 38345,
	"./qa-comments.mdx": 61582,
	"./razorpay.mdx": 97405,
	"./render.mdx": 86580,
	"./reports.mdx": 79248,
	"./revenuemodel.mdx": 63676,
	"./review-ratings.mdx": 84053,
	"./schedules.mdx": 93118,
	"./screens.mdx": 5586,
	"./search.mdx": 78533,
	"./seo.mdx": 12137,
	"./setup-app.mdx": 28309,
	"./social.mdx": 23344,
	"./stripe-connect.mdx": 92647,
	"./stripe-onboarding.mdx": 16764,
	"./stripe-payments.mdx": 53402,
	"./stuart.mdx": 6882,
	"./submit-template.mdx": 75493,
	"./subscription.mdx": 69764,
	"./tags.mdx": 40409,
	"./tax.mdx": 27763,
	"./template-create.mdx": 25013,
	"./testingapp.mdx": 48315,
	"./tracking.mdx": 78001,
	"./translations.mdx": 22339,
	"./twilio.mdx": 65268,
	"./users.mdx": 12464,
	"./variants.mdx": 65949,
	"./vercel.mdx": 75005,
	"./wallet.mdx": 99097,
	"./webhook.mdx": 44717,
	"./website.mdx": 67419,
	"./wishlist.mdx": 56012,
	"./zapier.mdx": 72957,
	"src/pages/docs/accounts.mdx": 69056,
	"src/pages/docs/adding-custom-styles.mdx": 90986,
	"src/pages/docs/appcustomisation.mdx": 48317,
	"src/pages/docs/appfeatures.mdx": 11260,
	"src/pages/docs/appstore.mdx": 35773,
	"src/pages/docs/attributes.mdx": 25192,
	"src/pages/docs/auth.mdx": 38430,
	"src/pages/docs/branch.mdx": 56400,
	"src/pages/docs/build-marketplace.mdx": 94485,
	"src/pages/docs/category.mdx": 31910,
	"src/pages/docs/chat.mdx": 87630,
	"src/pages/docs/checklist.mdx": 63113,
	"src/pages/docs/cloudflare.mdx": 26716,
	"src/pages/docs/collection.mdx": 49128,
	"src/pages/docs/commerce-definitions.mdx": 83544,
	"src/pages/docs/commission.mdx": 67221,
	"src/pages/docs/composer.mdx": 68939,
	"src/pages/docs/coupon.mdx": 7000,
	"src/pages/docs/crowdfunding.mdx": 37177,
	"src/pages/docs/currency.mdx": 37607,
	"src/pages/docs/deeplinks.mdx": 48576,
	"src/pages/docs/delivery.mdx": 38819,
	"src/pages/docs/deployment.mdx": 80390,
	"src/pages/docs/domain.mdx": 61798,
	"src/pages/docs/dynamic-page.mdx": 56331,
	"src/pages/docs/editing-page-styles.mdx": 77659,
	"src/pages/docs/editor-overview.mdx": 60285,
	"src/pages/docs/education.mdx": 75562,
	"src/pages/docs/email.mdx": 14095,
	"src/pages/docs/energy.mdx": 37816,
	"src/pages/docs/facebookapp.mdx": 21918,
	"src/pages/docs/firebase.mdx": 9793,
	"src/pages/docs/food.mdx": 30531,
	"src/pages/docs/ga.mdx": 96569,
	"src/pages/docs/google-maps.mdx": 76536,
	"src/pages/docs/growth.mdx": 93959,
	"src/pages/docs/integrations-overview.mdx": 62951,
	"src/pages/docs/inventory.mdx": 89182,
	"src/pages/docs/karix.mdx": 77992,
	"src/pages/docs/language.mdx": 89406,
	"src/pages/docs/listings.mdx": 11866,
	"src/pages/docs/location.mdx": 26787,
	"src/pages/docs/mangopay.mdx": 94691,
	"src/pages/docs/media.mdx": 79297,
	"src/pages/docs/negotiations.mdx": 30293,
	"src/pages/docs/netlify.mdx": 53165,
	"src/pages/docs/notifications.mdx": 33775,
	"src/pages/docs/onlinepaymentplatform.mdx": 84096,
	"src/pages/docs/order.mdx": 24521,
	"src/pages/docs/othersolutions.mdx": 11906,
	"src/pages/docs/paydunya.mdx": 64811,
	"src/pages/docs/paymentgateways.mdx": 30688,
	"src/pages/docs/playstore.mdx": 41394,
	"src/pages/docs/products.mdx": 19904,
	"src/pages/docs/promotion.mdx": 38345,
	"src/pages/docs/qa-comments.mdx": 61582,
	"src/pages/docs/razorpay.mdx": 97405,
	"src/pages/docs/render.mdx": 86580,
	"src/pages/docs/reports.mdx": 79248,
	"src/pages/docs/revenuemodel.mdx": 63676,
	"src/pages/docs/review-ratings.mdx": 84053,
	"src/pages/docs/schedules.mdx": 93118,
	"src/pages/docs/screens.mdx": 5586,
	"src/pages/docs/search.mdx": 78533,
	"src/pages/docs/seo.mdx": 12137,
	"src/pages/docs/setup-app.mdx": 28309,
	"src/pages/docs/social.mdx": 23344,
	"src/pages/docs/stripe-connect.mdx": 92647,
	"src/pages/docs/stripe-onboarding.mdx": 16764,
	"src/pages/docs/stripe-payments.mdx": 53402,
	"src/pages/docs/stuart.mdx": 6882,
	"src/pages/docs/submit-template.mdx": 75493,
	"src/pages/docs/subscription.mdx": 69764,
	"src/pages/docs/tags.mdx": 40409,
	"src/pages/docs/tax.mdx": 27763,
	"src/pages/docs/template-create.mdx": 25013,
	"src/pages/docs/testingapp.mdx": 48315,
	"src/pages/docs/tracking.mdx": 78001,
	"src/pages/docs/translations.mdx": 22339,
	"src/pages/docs/twilio.mdx": 65268,
	"src/pages/docs/users.mdx": 12464,
	"src/pages/docs/variants.mdx": 65949,
	"src/pages/docs/vercel.mdx": 75005,
	"src/pages/docs/wallet.mdx": 99097,
	"src/pages/docs/webhook.mdx": 44717,
	"src/pages/docs/website.mdx": 67419,
	"src/pages/docs/wishlist.mdx": 56012,
	"src/pages/docs/zapier.mdx": 72957
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66708;